import { render, staticRenderFns } from "./recommendData.vue?vue&type=template&id=045ab1b6&scoped=true&"
import script from "./recommendData.vue?vue&type=script&lang=js&"
export * from "./recommendData.vue?vue&type=script&lang=js&"
import style0 from "./recommendData.vue?vue&type=style&index=0&id=045ab1b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045ab1b6",
  null
  
)

export default component.exports